import * as $ from 'jquery';
import 'bootstrap';
var headroom = require('headroom');

export class secondaryNav {
	private $expSecondaryNav:any = $('.secondary-nav--container');

	selectSecondaryNav():void{
		let urlPathName = new URL(window.location.href).pathname;
		

		$('.sec-navigation ul li a').each(function(i:number, a:any) {
			var $authUrl = $(a); 
			if($authUrl.attr("href") != null && $authUrl.attr("href") != ''){
				if($authUrl.attr("href").includes(urlPathName)){
					$authUrl.addClass('hvr-underline-active').removeClass('hvr-underline-from-left');
				}
			}
		  });
	}
	fixedNavigation(): void {
		let _self = this;
		// initialize headroom
		let $mainBookingNav: any = $('#slide-nav');
		let $expSecondaryNavOffsetTop:any = $mainBookingNav.offset().top + $mainBookingNav.height();

	}

	secondaryNavScroll(): void {
		$('.view-content').click(function() {
			$('html, body').animate({
				scrollTop: 150
			}, 1500);
		});
		let $containerHeight: any = $('.img-content--wrapper').height();

		$('.sec-navigation ul li a').click(function() {
			if ($(this).hasClass('btn-primary')) {
				console.log('btn-primary');
				return;
			}

			let $scrollTopEl: any = $('#detailed-content--'+$(this).attr('data-target'));

			if ($scrollTopEl.length) {
				let $scrollTop:any = $scrollTopEl.offset().top - 120;
				$('html, body').animate({scrollTop: $scrollTop}, 1500);
			}
		});

		let $viewportWidth:any = $(window).width();
		$(window).load(function() {
			if($viewportWidth < 767){
				let $secondaryNav: any = $('.sec-navigation, .sec-navigation ul li');
				let $secondaryNavLi: any = $('.sec-navigation ul li').length;
				if($secondaryNavLi > 3){
					let $secondaryNavArrow: any = $('.sec-nav--arrow');
					$secondaryNavArrow.show();
					$secondaryNav.on('touchstart mousedown', function(e:any){
						$secondaryNavArrow.css('opacity', 0);
					});
					$secondaryNav.on('touchend mouseup', function(e:any){
						$secondaryNavArrow.css('opacity', 0.2);
					});
				}
			} else{
				let $secondaryNav: any = $('.sec-navigation, .sec-navigation ul li');
				let $secondaryNavLi: any = $('.sec-navigation ul li').length;
				if($secondaryNavLi > 7){
					let $secondaryNavArrow: any = $('.sec-nav--arrow');
					$secondaryNavArrow.show();
					$secondaryNav.on('touchstart mousedown', function(e:any){
						$secondaryNavArrow.css('opacity', 0);
					});
					$secondaryNav.on('touchend mouseup', function(e:any){
						$secondaryNavArrow.css('opacity', 0.2);
					});
				}
			}
		});

		let $secondaryNav: any = $('.sec-navigation');
		let $secondaryNavArrow: any = $('.sec-nav--arrow');
		$secondaryNav.on('touchstart mousedown', function(e:any){
			$secondaryNavArrow.css('opacity', 0);
		});
		$secondaryNav.on('touchend mouseup', function(e:any){
			$secondaryNavArrow.css('opacity', 0.2);
		});
	}

	mouseScrollSecondaryNav(): void {
		let curYPos:any;
		let curXPos:any;
		let curDown:any;
		let curLPos:any;
		let _self = this;
		let $secNav = _self.$expSecondaryNav.find('.sec-navigation');

		_self.$expSecondaryNav[0].addEventListener('mousemove', function(e:any){
			if(curDown){
				$secNav.scrollLeft(curLPos + (curXPos - e.pageX));
								// window.scrollTo(document.body.scrollLeft + (curXPos - e.pageX), document.body.scrollTop);
							}
						});

		window.addEventListener('mousedown', function(e:any){
			curYPos = e.pageY;
			curXPos = e.pageX;
			curDown = true;
			curLPos = $secNav.scrollLeft();
		});

		window.addEventListener('mouseup', function(e:any){
			curDown = false;
		});
	}
}

let scope:Element = document.querySelector('.secondary-nav--container');
if (scope){
	try {
		let secondarynav = new secondaryNav();
		secondarynav.selectSecondaryNav();
		secondarynav.secondaryNavScroll();
		secondarynav.mouseScrollSecondaryNav();
		
	} catch(e) {console.error(e);}
}
